import { FormattedDate } from 'components/Formatters';
import Timeline from 'components/Timeline';
import { isBefore, parseISO } from 'date-fns';
import { getPendingScheduledPayment } from 'lib/bookingInfo';
import { ReactNode } from 'react';
import { SelfServiceAPI } from 'types';
import RefundDescription from '../RefundDescription';
import ScheduledPaymentItem from '../ScheduledPaymentItem';

interface Props {
  booking: SelfServiceAPI.Booking;
}

const RefundTimelineItems = ({ booking }: Props) => {
  const scheduledPayment = getPendingScheduledPayment(booking);
  let shouldIncludedSchedulePayment = !!scheduledPayment;

  return (
    <>
      {booking.reservation.cancellationPolicy!.cancellationWindows.reduce<ReactNode[]>((items, cancellationWindow, index, windows) => {
        const shouldIncludeCancellationWindowItem = isBefore(
          parseISO(cancellationWindow.startTime),
          parseISO(booking.reservation.checkInDateTime),
        );
        const isLastWindow = index === windows.length - 1;
        const additionalInfo = index === 0 ? <FormattedDate date={booking.createdAt} /> : undefined;
        const showDaysCount = index !== 0;
        const timelineItem = shouldIncludeCancellationWindowItem ? (
          <Timeline.Item
            key={index}
            iconName={index === 0 ? 'confirmation' : undefined}
            iconColor={index === 0 ? 'green' : undefined}
            state={cancellationWindow.isFullyRefundable ? 'completed' : 'pending'}
            title={index === 0 ? 'Reservation confirmed' : <FormattedDate date={cancellationWindow.startTime} />}
            description={
              <RefundDescription
                cancellationWindow={cancellationWindow}
                checkInDateTime={booking.reservation.checkInDateTime}
                showDaysCount={showDaysCount}
                additionalInfo={additionalInfo}
              />
            }
          />
        ) : null;

        switch (true) {
          case shouldIncludedSchedulePayment && isBefore(parseISO(scheduledPayment!.deferredTo), parseISO(cancellationWindow.startTime)):
            shouldIncludedSchedulePayment = false;
            return [...items, <ScheduledPaymentItem key="schedule-payment-item" booking={booking} />, timelineItem];
          case shouldIncludedSchedulePayment && isLastWindow:
            shouldIncludedSchedulePayment = false;
            return [...items, timelineItem, <ScheduledPaymentItem key="schedule-payment-item" booking={booking} />];
          default:
            return [...items, timelineItem];
        }
      }, [])}
    </>
  );
};

export default RefundTimelineItems;
